import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getEvent } from '../config/events';

const FAQ = () => {
  const { eventId } = useParams();
  const event = getEvent(eventId || 'youth-bootcamp');

  const faqItems =
    event.id === 'couples-conference'
      ? [
          {
            question: "Who can attend the Couples Conference?",
            answer: "This conference is designed for married couples of all ages and stages of marriage. Whether you're newlyweds or have been married for decades, you'll find valuable insights and tools to strengthen your relationship.",
          },
          {
            question: "What should we expect during the conference?",
            answer: "The conference includes worship sessions, keynote speakers, breakout sessions, couple activities, and time for personal reflection. All content is designed to help you grow closer to God and each other.",
          },
          {
            question: "Do we need to attend together?",
            answer: "Yes, this conference is specifically designed for couples to attend together. The activities and sessions are built around couple participation and interaction.",
          },
        ]
      : event.id === 'women-of-noble-character'
      ? [
          {
            question: "Who can attend the Women of Noble Character conference?",
            answer: "This conference is open to all women who want to grow in faith and be inspired. Whether you're a young adult or a seasoned woman of God, you are welcome to join us.",
          },
          {
            question: "What should I expect during the conference?",
            answer: "The conference spans two days — Friday May 29 and Saturday May 30, 2026. Expect powerful worship, a keynote message from Prophetess Bola Sarah Adedimeji, breakout sessions, prayer, and fellowship with other women.",
          },
          {
            question: "Who is hosting the conference?",
            answer: "The conference is hosted by Servante Namish Mpeti, with Prophetess Bola Sarah Adedimeji as the guest speaker.",
          },
          {
            question: "How can I get more information?",
            answer: "For any questions, please reach out to us at info@jesuslebonberger.org.",
          },
        ]
      : event.id === 'youth-conference'
      ? [
          {
            question: "Who can attend the Youth Conference?",
            answer: "The Annual Youth Conference is open to youth and young adults. Whether you're a teenager or a young adult looking to deepen your faith, you are welcome to join us for this powerful two-day event.",
          },
          {
            question: "What should I expect at the conference?",
            answer: "Expect two powerful days of worship, anointed preaching, prayer, and fellowship. You'll hear from our host and anointed guest speakers as we explore what it truly means for Jesus Christ to count on you.",
          },
          {
            question: "What should I bring?",
            answer: "Please bring your Bible, a journal, an open heart, and a willingness to be transformed. Dress comfortably and come ready to encounter God.",
          },
          {
            question: "Is there a registration fee?",
            answer: "Please contact us at info@jesuslebonberger.org for registration details and any associated fees.",
          },
          {
            question: "Where is the conference held?",
            answer: "The conference is held at 221 N Dooley Street, Grapevine, TX 76051. Parking is available on site.",
          },
        ]
      : [
          {
            question: "What should I bring to the boot camp?",
            answer: "Please bring: 1) Bible and journal, 2) Comfortable clothes for 3 days, 3) Athletic shoes, 4) Toiletries, 5) Sleeping bag or twin bedding, 6) Pillow and towel, 7) Refillable water bottle, 8) Sunscreen, 9) Any necessary medications, 10) Light jacket or sweater for evenings.",
          },
          {
            question: "What activities will be included?",
            answer: "The boot camp includes worship sessions, Bible study, team-building exercises, outdoor challenges, sports competitions, talent showcase, prayer sessions, and mentoring opportunities with youth leaders.",
          },
          {
            question: "Are meals provided?",
            answer: "Yes, all meals are provided from Monday through Wednesday. If you have dietary restrictions, please let us know.",
          },
        ];

  return (
    <section className="py-5 bg-light" id="faq">
      <Container>
        <h2 className="text-center fw-bold mb-5">Frequently Asked Questions</h2>

        <Row className="justify-content-center">
          <Col lg={10}>
            <Accordion className="mb-5">
              {faqItems.map((item, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>{item.question}</Accordion.Header>
                  <Accordion.Body>{item.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>

            <div className="text-center mt-5" id="contact">
              <h3 className="fw-bold mb-4">Contact Us</h3>
              <Row className="justify-content-center">
                <Col md={6} className="mb-4">
                  <div className="contact-card p-4 bg-light rounded shadow-sm">
                    <h4 className="h5 mb-3">General Questions</h4>
                    <p><i className="bi bi-envelope me-2"></i><a href="mailto:info@jesuslebonberger.org">info@jesuslebonberger.org</a></p>
                    <p><i className="bi bi-telephone me-2"></i>(555) 123-4567</p>
                  </div>
                </Col>
                <Col md={6} className="mb-4">
                  <div className="contact-card p-4 bg-light rounded shadow-sm">
                    <h4 className="h5 mb-3">Registration Support</h4>
                    <p><i className="bi bi-envelope me-2"></i><a href="mailto:info@jesuslebonberger.org">info@jesuslebonberger.org</a></p>
                    <p><i className="bi bi-telephone me-2"></i>(817) 987-3444</p>
                  </div>
                </Col>
              </Row>
              <p className="mt-3">Our team is available Monday-Friday, 9am-5pm CT</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FAQ;
